import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  EMPLOYEES_LIST_PERMISSIONS,
  EMPLOYEES_LIST_ROUTE_NAME,
  EMPLOYEES_MAIN_ROUTE_NAME,
  TRANSLATION_GROUP_EMPLOYEES_LIST,
} from '@modules/employees/constants';
import { EmployeesCreateModule } from '@modules/employees/submodules/create/EmployeeCreateModule';
import { EmployeesEditModule } from '@modules/employees/submodules/edit/EmployeeEditModule';
import { getTranslationKeys } from '@modules/employees/translations';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_PERSONNEL_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

export class EmployeesModule extends AppModule {
  protected submodules = [
    new EmployeesEditModule(),
    new EmployeesCreateModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: EMPLOYEES_MAIN_ROUTE_NAME,
      path: 'employees',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'EmployeesListPage',
      permission: EMPLOYEES_LIST_PERMISSIONS.SHOW,
    });

    router.addChildRoute(EMPLOYEES_MAIN_ROUTE_NAME, {
      name: EMPLOYEES_LIST_ROUTE_NAME,
      path: '',
      component: () => import('@modules/employees/pages/EmployeesListPage/EmployeesListPage.vue'),
      permission: EMPLOYEES_LIST_PERMISSIONS.SHOW,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PERSONNEL_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PERSONNEL_PERSONNEL_LIST'),
      to: { name: EMPLOYEES_LIST_ROUTE_NAME },
      id: EMPLOYEES_LIST_ROUTE_NAME,
      permission: EMPLOYEES_LIST_PERMISSIONS.SHOW,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_EMPLOYEES_LIST, getTranslationKeys);
  }
}
